import React from 'react';
import { isDate } from 'date-fns';
import { getZonedDateStringFromDateString, getDateStringFromZonedDate } from 'ezyvet-fe-helpers';
/**
 * @deprecated
 */
function DateTime(props) {
    var value = props.value, format = props.format, timezone = props.timezone;
    var getFormattedValue = function () {
        var result = value;
        if (!result)
            return null;
        if (isDate(result))
            result = getDateStringFromZonedDate(result, timezone);
        return getZonedDateStringFromDateString(result, timezone, format);
    };
    return React.createElement(React.Fragment, null, getFormattedValue());
}
DateTime.defaultProps = {
    timezone: 'Etc/UTC',
    format: 'yyyy-MM-dd HH:mm:ss',
};
export default DateTime;
//# sourceMappingURL=DateTime.js.map